export enum CalendarRange {
  DAY = 'CALENDAR_RANGE/DAY',
  WEEK = 'CALENDAR_RANGE/WEEK',
  MONTH = 'CALENDAR_RANGE/MONTH',
  LISTWEEK = 'CALENDAR_RANGE/LISTWEEK'
}
